import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import { useState } from 'react';
import LoadingButton from '@/components/Buttons/LoadingButton';

interface Props {
    contactName: string;
    contactEmail: string;
    onClose: () => void;
    onConfirm: () => Promise<void>;
}

export default function RemoveContactDialog({
    contactName,
    contactEmail,
    onClose,
    onConfirm,
}: Props) {
    const [isRemoving, setIsRemoving] = useState(false);

    const handleConfirm = async () => {
        setIsRemoving(true);
        try {
            await onConfirm();
        } finally {
            setIsRemoving(false);
        }
    };

    return (
        <Dialog
            open
            onClose={(_event, reason) => {
                if (reason === 'backdropClick' && isRemoving) return;
                onClose();
            }}
        >
            <DialogTitle>Remove contact</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Are you sure you want to remove this contact? Their draft answers and submitted
                    intake details will be removed from this prospect.
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                    {contactName || contactEmail}
                </Typography>
                {contactName && (
                    <Typography variant="body2" color="text.secondary">
                        {contactEmail}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isRemoving}>
                    Cancel
                </Button>
                <LoadingButton
                    onClick={handleConfirm}
                    loading={isRemoving}
                    color="error"
                    variant="contained"
                >
                    Remove
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
